import { getBaseThemeName } from "@/features/branding";
import { ResultsMode } from "@/features/pe_aldd/schema";
import { facadesUrl } from "@/store/services/facades";

// Retry stream on network failures
export const streamResults = async (
  ids: string[],
  stamps: string[],
  maxRetries = 10,
  timeout = 3000,
  resultsMode: ResultsMode = "comprehensive"
): Promise<Response> => {
  let retryCount = 0;
  let error: Error | null = null;

  console.log(`[Download] Streaming results for ${ids.length} assets.`);

  while (retryCount <= maxRetries) {
    try {
      const facadesPath =
        getBaseThemeName() === "hkma" && resultsMode === "simple" ? "project_halo" : `structural/${resultsMode}`;

      const url = new URL(`${facadesUrl}${facadesPath}/results`);

      if (stamps.length) {
        stamps.forEach((stamp) => url.searchParams.append("stamps", stamp));
      }

      const response = await fetch(url.toString(), {
        method: "POST",
        headers: {
          Authorization: `Basic ${process.env.NEXT_PUBLIC_FACADES_ABCDE_API_KEY}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(ids),
      });

      if (!response.ok) {
        throw new Error(`Stream request failed with status: ${response.status}`);
      }

      return response;
    } catch (e: unknown) {
      retryCount++;
      error = e instanceof Error ? e : new Error(String(e));

      if (retryCount > maxRetries) {
        console.error(`Maximum retries reached for streamResults`);
        break;
      }

      console.warn(`Retry attempt ${retryCount}/${maxRetries} for streamResults failed: ${error?.message}`);
      await new Promise((resolve) => setTimeout(resolve, timeout));
    }
  }

  throw new Error(`Failed to stream results after ${maxRetries} attempts: ${error?.message}`);
};
